import React, { useCallback } from "react";
import { emitMigrationNudgeAction, emitMigrationNudgeImpression, } from "@catchoftheday/analytics";
import { useIsInViewport } from "@catchoftheday/utilities";
import { MigrationNudge } from "../../pure/MigrationNudge";
export const MigrationNudgeContainer = ({ CTAUrl }) => {
    const trackImpressions = useCallback(() => {
        emitMigrationNudgeImpression();
    }, []);
    const trackCTAClicks = useCallback(() => {
        emitMigrationNudgeAction("proceed");
    }, []);
    const { ref } = useIsInViewport({
        onComponentSeen: trackImpressions,
    });
    return (<MigrationNudge ref={ref} CTAUrl={CTAUrl} onCTAClick={trackCTAClicks}/>);
};
